export appleTouchIcon from './apple-touch-icon.png'
export favicon32x32 from './favicon-32x32.png'
export favicon16x16 from './favicon-16x16.png'
export safariPinnedTab from './safari-pinned-tab.svg'



// WEBPACK FOOTER //
// ./src/img/meta/metas.js